import { ReactNode } from 'react';
import { CSSObjectWithLabel } from 'react-select';
import { DefaultTheme } from 'ui/selectv2/Themes';
import { borderColors, colors, duration, easing, spacing, subtleShadow } from 'ui/theme';

export const ConditionMultiValueTheme =
  ({
    isEmpty,
    shouldHideDisplayValues = false,
  }: { isEmpty: boolean; shouldHideDisplayValues?: boolean }) =>
  (errorMsg?: ReactNode) => {
    const defaultTheme = DefaultTheme(errorMsg);
    return {
      ...defaultTheme,
      control: (baseStyles: CSSObjectWithLabel) => ({
        ...defaultTheme.control(baseStyles),
        minHeight: 31, // cant use height 32 as height NEEDS to be 100%
        boxShadow: 'none',
        ...(shouldHideDisplayValues
          ? {
              border: 'none',
              '&:hover': {},
            }
          : {}),
      }),
      placeholder: (baseStyles: CSSObjectWithLabel) => ({
        ...defaultTheme.placeholder(baseStyles),
        padding: `0 ${spacing.quarter}`,
      }),
      multiValue: (baseStyles: CSSObjectWithLabel) => ({
        ...defaultTheme.multiValue(baseStyles),
        padding: `${spacing.eighth} ${spacing.half}`,
        ...(shouldHideDisplayValues
          ? {
              margin: `0 ${spacing.single} ${spacing.eighth} ${spacing.single}`,
            }
          : {
              margin: `${spacing.single} ${spacing.eighth}`,
            }),
      }),
      valueContainer: (baseStyles: CSSObjectWithLabel) => ({
        ...defaultTheme.valueContainer(baseStyles),
        ...(shouldHideDisplayValues
          ? {
              ...subtleShadow,
              padding: spacing.quarter,
              margin: spacing.half,
              width: '100%',
              borderColor: colors.grey15,
              cursor: 'text',
              borderStyle: 'solid',
              borderRadius: spacing.quarter,
              borderWidth: spacing.single,
              '&:hover': {
                border: `1px solid ${borderColors.borderInteractive}`,
                transition: `all ${duration.short} ${easing.entrance}`,
              },
              '&:focus-within': {
                borderColor: borderColors.borderInteractive,
                boxShadow: `0px 0px 0px 1px ${colors.purple50}`,
              },
            }
          : {
              padding: spacing.single,
            }),
      }),
      indicatorsContainer: (baseStyles: CSSObjectWithLabel) => ({
        ...defaultTheme.indicatorsContainer(baseStyles),
        ...(shouldHideDisplayValues
          ? {
              display: 'none',
            }
          : {
              height: 31,
            }),
      }),
      input: (baseStyles: CSSObjectWithLabel) => ({
        ...defaultTheme.input(baseStyles),
        margin: spacing.single,
        padding: 0,
        ...(isEmpty && { marginLeft: spacing.threeEights }),
      }),
    };
  };
